<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="login" flat style="border-radius: 10px; padding: 10px;">
              <v-card-text style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <v-data-iterator v-show="iterador.conteudo.length > 0" :items="iterador.conteudo" :search="iterador.busca" :items-per-page.sync="iterador.itensPorPagina" hide-default-footer>
                        <template v-slot:header>
                          <v-text-field style="margin-bottom: 10px" color="#ffffff" v-model="iterador.busca" dense outlined clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Pesquisa"></v-text-field>
                        </template>
                        <template v-slot:default="props">
                          <v-row dense>
                            <v-col v-for="item in props.items" :key="item.name" cols="6" sm="6" md="6" lg="6">
                              <v-card style="border: #474C56 3px solid" flat>
                                <v-img width="100%" height="100%" max-height="130px" min-height="130px" :src="item.urlImagem" :lazy-src="item.urlImagem" @click="item.estoque > 0 ? adicionaItem(item) : ''" class="white--text align-end" :style="item.estoque > 0 ? '' : 'filter: grayscale(1)'">
                                  <div style="padding-left: 10px; background: rgb(255,255,255); background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(71,76,86,0.6090828176973915) 10%, rgba(71,76,86,0.76874668324361) 25%);">
                                    <p style="text-align: left; margin: 0px; padding-top: 10px; height: 25px"><b>{{ item.descricao }}</b></p>
                                    <p style="text-align: right; margin-bottom: 0px; margin-top: 5px">R$ {{ item.preco }}</p>
                                  </div>
                                </v-img>
                                <v-list dense style="padding: 0px">
                                  <v-divider></v-divider>
                                  <v-list-item style="text-align: center; padding-left: 8px; padding-right: 8px">
                                    <v-list-item-content>
                                      <v-row justify="center" align="center" dense v-if="item.estoque > 0">
                                        <v-col cols="4">
                                          <v-btn block color="error" @click="removeItem(item)" :disabled="!item.quantidade">
                                            <v-icon dark>remove</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="4">
                                          <p style="font-weight: bold; font-size: 22px; text-align: center; margin: 0px">{{ quantidadeDeItem(item.id) }}</p>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-btn style="padding: 2px;"  dark block color="orange" @click="openDialogObs(item)">Obs.</v-btn>
                                        </v-col>
                                      </v-row>
                                      <v-row justify="center" align="center" dense v-else>
                                        <v-col cols="12">
                                          <v-alert dense style="margin: 0px; font-weight: bold" color="red" dark>ESGOTADO</v-alert>
                                        </v-col>
                                      </v-row>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-card>
                            </v-col>
                            <v-col cols="6">
                              <v-card style="border: #474C56 3px solid" @click="dialogoItemAvulso = true" flat>
                                <div style="text-align: center">
                                  <v-icon style="height: 130px" size="80px">mdi-help</v-icon>
                                </div>
                                <v-divider></v-divider>
                                <v-list dense style="height: 51px; padding-bottom: 0px">
                                  <div style="padding-left: 10px">
                                    <p style="margin: 0px"><b>Venda Avulsa</b></p>
                                    <p style="margin-bottom: 0px; margin-top: 5px; color: darkgreen"></p>
                                  </div>
                                </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-iterator>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-show="!iterador.conteudo.length > 0">
                      <v-text-field label="Valor" outlined hide-details v-model="valorTransacao" v-money="money" prefix="R$" type="tel" color="#474d55" dense id="campoValor"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-show="!iterador.conteudo.length > 0">
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode">
                        <v-icon left size="25">mdi-cash-clock</v-icon>Receber
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="consultarSaldo">
                        <v-icon left size="25">mdi-magnify</v-icon>Consultar Saldo
                      </v-btn>
                    </v-flex>
                      <v-card outlined>
                        <v-card-title style="font-size: 15px; padding-top: 5px; padding-bottom: 5px">Últimas transações</v-card-title>
                        <div v-show="!tabela.carregamentoMinimizado">
                          <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-for="transacao in tabela.conteudoMinimizado" :key="transacao.id" justify-center style="padding: 0px">
                            <v-list dense>
                              <v-list-item>
                                <v-list-item-avatar style="margin-top: 0px; margin-bottom: 0px">
                                  <v-avatar :color="transacao.tipoTransacao == 'CONSUMO' ? 'success' : 'orange'">
                                    <v-icon dark left size="30" v-show="transacao.tipoTransacao == 'CONSUMO'">mdi-cash-plus</v-icon>
                                    <v-icon dark left size="30" v-show="transacao.tipoTransacao == 'ESTORNO'">mdi-cash-refund</v-icon>
                                  </v-avatar>
                                </v-list-item-avatar>

                                <v-list-item-content style="padding: 0px">
                                  <v-list-item-title>{{ transacao.consumidor && transacao.consumidor.nome ? transacao.consumidor.nome : 'Consumidor removido' }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ formatDate(transacao.created.substring(0, 10)).substring(0, 5) }} às {{ transacao.created.substring(11, 16) }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-list-item-subtitle><b>R$ {{ transacao.valor }}</b></v-list-item-subtitle>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                          </v-col>
                        </div>
                        <div v-show="tabela.carregamentoMinimizado" style="text-align: center; padding: 10px">
                          <v-progress-circular indeterminate></v-progress-circular>
                          <p>Carregando últimas transações...</p>
                        </div>
                        <div v-show="!tabela.carregamentoMinimizado && tabela.conteudoMinimizado.length == 0" style="text-align: center; padding: 10px">
                          <v-alert class="mb-0" type="info" dense text>Nenhuma transação realizada</v-alert>
                        </div>
                        <v-btn v-show="!tabela.carregamentoMinimizado && tabela.conteudoMinimizado.length > 0" style="width: 100%" @click="mostraHistorico" text>
                          <v-icon left>history</v-icon>Ver mais
                        </v-btn>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logo-branco-orizontal.png" width="150px">
          </a>
        </div>
      </v-container>

      <v-footer dark padless class="footer" app v-if="pedido.itensPedido.length > 0">
        <v-card class="flex" flat tile color="#37474F">
          <v-card-title>
            <span>
              Total: R$ <strong class="subheading">{{pedido.valor.replace('.', ',')}}</strong>
            </span>
            <v-btn color="#EF6C00" dark x-small outlined fab class="ma-2" @click="recarregaPedido">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="ma-2" color="teal" @click="dialogoCompra = true">Continuar</v-btn>
          </v-card-title>
        </v-card>
      </v-footer>

      <v-dialog persistent v-model="dialogoCaptura" max-width="600px">
        <v-card>
          <v-card-title>Leitura do cartão</v-card-title>
          <v-card-text style="padding: 0px">
            <v-row dense style="margin: 0px; text-align: center">
              <v-col cols="12">
                <img width="200px" src="../../assets/iconContactless.png">
              </v-col>
              <v-col cols="12">
                <h3>Aproxime o cartão no leitor da maquineta</h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoCriaPin" max-width="400px">
        <v-card>
          <v-card-title>Criar PIN</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <p>Crie um código PIN para efetuar depositos e saques. O PIN deverá ter 04 (quatro) números.</p>
            <v-otp-input length="4" color="#474d55" type="number" v-model="pin"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" :disabled="pin.length < 4" @click="salvarPin">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitaPin" max-width="400px">
        <v-card>
          <v-card-title>Solicite a senha</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <v-otp-input id="pinTransacao" autofocus="true" length="4" color="#474d55" type="number" v-model="pinTransacao" v-if="situacao == ''" @finish="criarTransacao(false)"></v-otp-input>
            <v-otp-input id="pinTransacao" autofocus="true" length="4" color="#474d55" type="number" v-model="pinTransacao" v-if="situacao == 'ESTORNO'" @finish="criarEstorno"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="fechar">Fechar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarTransacao(false)" v-if="situacao == ''">Continuar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarEstorno" v-if="situacao == 'ESTORNO'">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoOperacao" max-width="600px">
        <v-card>
          <v-card-text style="padding-bottom: 0px; padding-top: 24px; text-align: center">
            <v-icon size="100" :color="respostaTransacao.resultado == 'SUCESSO' ? 'success' : 'error'">{{ respostaTransacao.resultado == 'SUCESSO' ? 'check_circle' : 'error' }}</v-icon>
            <p v-if="respostaTransacao.resultado == 'SUCESSO'" style="font-size: 20px">Sucesso</p>
            <p v-if="respostaTransacao.resultado == 'SALDO_INSUFICIENTE'" style="font-size: 20px">Saldo insuficiente</p>
            <h1 style="margin: 0px; font-weight: 300">{{ respostaTransacao.consumidor }}</h1>
            <h3 style="margin-bottom: 0px; margin-top: 10px">Saldo</h3>
            <h1 style="margin: 0px; font-weight: 300; margin-top: 10px">R$ {{ respostaTransacao.saldo }}</h1>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoOperacao = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoHistorico" transition="dialog-bottom-transition" max-width="600px" scrollable>
        <v-card>
          <v-toolbar color="#474d55" dark dense>
            <v-toolbar-title>Histórico</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogoHistorico = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="padding: 0px">
            <v-data-iterator :items="tabela.conteudoCompleto" :items-per-page.sync="tabela.itensPorPagina" :page.sync="tabela.pagina" :loading="tabela.carregamentoCompleto" :search="tabela.busca">
              <template v-slot:header>
                <v-toolbar dark color="blue darken-3" class="mb-0">
                  <v-text-field v-model="tabela.busca" dense clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Pesquisa"></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:no-results>
                <v-alert style="margin: 10px" type="info" dense text>Sua busca por "{{ tabela.busca }}" não trouxe resultados</v-alert>
              </template>
              <template v-slot:no-data>
                <v-alert style="margin: 10px" type="info" dense text>Nenhum registro localizado</v-alert>
              </template>
              <template v-slot:loading>
                <div style="text-align: center; padding: 20px">
                  <p style="margin-bottom: 5px">Aguarde, carregando itens...</p>
                  <v-progress-linear indeterminate></v-progress-linear>
                </div>
              </template>
              <template v-slot:default="props">
                <v-col v-for="item in props.items" :key="item.name" cols="12" style="padding: 0px">
                  <v-list dense>
                    <v-list-item @click="item.tipoTransacao == 'CONSUMO' ? efetuarEstorno(item) : ''">
                      <v-list-item-avatar style="margin-top: 0px; margin-bottom: 0px">
                        <v-avatar :color="item.tipoTransacao == 'CONSUMO' ? 'success' : 'orange'">
                          <v-icon dark left size="30" v-if="item.tipoTransacao == 'CONSUMO'">mdi-cash-plus</v-icon>
                          <v-icon dark left size="30" v-if="item.tipoTransacao == 'ESTORNO'">mdi-cash-refund</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>

                      <v-list-item-content style="padding: 0px">
                        <v-list-item-title>{{ item.nome }}</v-list-item-title>
                        <v-list-item-subtitle>{{ formatDate(item.created.substring(0, 10)).substring(0, 5) }} às {{ item.created.substring(11, 16) }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-subtitle><b>R$ {{ item.valor }}</b></v-list-item-subtitle>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                </v-col>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoItemAvulso" persistent max-width="400px">
        <v-card>
          <v-card-title>Venda avulsa</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field label="Valor" outlined hide-details v-model="avulso.preco" v-money="money" prefix="R$" type="tel" color="#474d55" dense id="avulsoValor"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Descrição" outlined hide-details v-model="avulso.descricao" color="#474d55" dense></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoItemAvulso = false">Fechar</v-btn>
            <v-btn depressed style="border-radius: 7px" @click="insereVendaAvulsa" color="primary" text>Receber</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog fullscreen persistent v-model="dialogoCompra" transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="teal">
            <v-toolbar-title>Resumo da compra</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialogoCompra = false">Voltar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div v-if="pedido.itensPedido.length > 0">
            <v-virtual-scroll :key="virtualScrollKey" :items="pedido.itensPedido" item-height="65" height="300" :bench="pedido.itensPedido.length">
              <template v-slot:default="{ item }">
                <v-list-item style="border: 1px #ddd solid">
                  <v-list-item-content>
                    <v-list-item-title>{{item.quantidade == undefined ? 0 : item.quantidade}}x {{ item.descricao }}</v-list-item-title>
                    <p v-if="item.observacao">Obs: {{ item.observacao }}</p>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-subtitle style="color: #00BFA5; font-weight: bold;">R$ {{ item.preco }}</v-list-item-subtitle>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </div>
          <v-footer dark fixed app color="#37474F" style="padding: 10px">
            <v-row>
              <v-col cols="12" align-self="center">
                <v-btn depressed block outlined large style="border-radius: 7px;" @click="valorTransacao = pedido.valor.replace('.', ','); abreLeituraQRCode()">
                  <v-icon left size="25">mdi-cash-clock</v-icon>Receber
                </v-btn>
              </v-col>
            </v-row>
          </v-footer>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoForcarTransacao" max-width="600px" persistent>
        <v-card>
          <v-card-title>Informação</v-card-title>
          <v-card-text>
            <p style="margin: 0px">Detectamos que uma transação com as mesmas informações foi processada em menos de 02 (dois) minutos. Deseja prosseguir mesmo assim?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoForcarTransacao = false">Cancelar</v-btn>
            <v-btn text color="primary" @click="criarTransacao(true)">Prosseguir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoSelecaoMetodo" max-width="400px" persistent>
        <v-card>
          <v-card-title>Método de Identificação</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn block color="primary" @click="selecionarMetodo('nfc')" height="70">
                    <v-icon left large>mdi-cellphone-nfc</v-icon>
                    Aproximação
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn block color="success" @click="selecionarMetodo('facial')" height="70">
                    <v-icon left large class="mr-4">mdi-face-recognition</v-icon>
                    Facial
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoSelecaoMetodo = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoCamera" max-width="500px" persistent>
        <v-card>
          <v-card-title style="padding: 5px 15px 5px 15px">
            Câmera
            <v-spacer></v-spacer>
            <v-btn @click="dialogoCamera = false" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" style="padding: 12px 0px">
                <v-item-group v-model="modoCaptura">
                  <v-item v-for="opcao in opcoesCaptura" :key="opcao.value" :value="opcao.value" v-slot="{ active, toggle }">
                    <v-chip label active-class="primary" :input-value="active" @click="toggle" class="mr-3">
                      <v-icon small left v-if="active">mdi-check</v-icon>
                      {{ opcao.text }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-col>

              <v-col cols="12" v-if="modoCaptura == 'FACIAL'" style="padding: 0px">
                <CameraView
                  ref="camera"
                  :ativo="modoCaptura == 'FACIAL' && dialogoCamera"
                  @cameras-detectadas="totalCameras = $event"
                />

                <div align="center" justify="center" style="padding-bottom: 8px">
                  <v-btn
                    v-if="totalCameras > 1"
                    @click="$refs.camera.alternarCamera()"
                    fab
                    dark
                    class="mr-3"
                  >
                    <v-icon large>mdi-camera-flip</v-icon>
                  </v-btn>
                  <v-btn
                    @click="capturarFoto"
                    fab
                    dark
                    depressed
                  >
                    <v-icon large>mdi-camera-iris</v-icon>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" v-else style="padding: 0px">
                <v-autocomplete
                  :loading="autocompleteConsumidor.carregamento"
                  :search-input.sync="autocompleteConsumidor.busca"
                  cache-items
                  :items="autocompleteConsumidor.conteudo"
                  :filter="filterConsumidores"
                  item-text="nome"
                  item-value="qrCode"
                  label="Consumidor"
                  outlined
                  hide-details
                  v-model="codigoQrCode"
                  no-data-text="Nenhum consumidor encontrado"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-img v-if="item.foto" :src="item.foto"></v-img>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-avatar>
                      <v-img v-if="item.foto" :src="item.foto"></v-img>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="modoCaptura != 'FACIAL'">
            <v-spacer></v-spacer>
            <v-btn v-if="tipoTransacao == 'CONSULTA'" text color="primary" :disabled="Boolean(!codigoQrCode)" @click="dialogoCamera = false; fazerConsultaSaldo(codigoQrCode)">Continuar</v-btn>
            <v-btn v-else text color="primary" :disabled="Boolean(!codigoQrCode)" @click="dialogoCamera = false; dialogoSolicitaPin = true">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  <!-- DIALOG OBS -->
    <v-dialog v-model="dialogObs" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Alguma observação?</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-textarea label="Escreva em poucas palavras suas observações..." outlined :value="obsProduto" @change="v => obsProduto = v"></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-btn color="teal darken-1" dark block @click="saveObs()">Salvar</v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-btn color="red darken-1" dark block @click="closeObs()">Fechar</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- DIALOG CONULTA SALDO -->
    <v-dialog persistent v-model="dialogoConsultaSaldo" max-width="600px">
        <v-card>
          <v-card-title>Leitura do cartão</v-card-title>
          <v-card-text style="padding: 0px">
            <v-row dense style="margin: 0px; text-align: center">
              <v-col cols="12">
                <img width="200px" src="../../assets/iconContactless.png">
              </v-col>
              <v-col cols="12">
                <h3>Aproxime o cartão no leitor da maquineta</h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoConsultaSaldo = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#474d55" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  /* global NDEFReader */
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import axios from 'axios'
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import { mapState } from 'vuex';
  import CameraView from '../../componentes/CameraView.vue'
  export default {
    components: { Snackbar, Loading, CameraView, },
    name: 'Caixa',
    data() {
      return {
        usuario: '',
        company: '',
        lojista: '',
        virtualScrollKey: 0,
        pin: '',
        pinTransacao: '',
        produtoObs: '',
        valorTransacao: 0.00,
        codigoQrCode: '',
        googleKey: "",
        hashBase64: "",
        iterador: {
          busca: '',
          categorias: [],
          conteudo: [],
          itensPorPagina: -1
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        consumidor: {
          nome: '',
          cpf: '',
          whatsApp: '',
          qrCode: '',
        },
        tabela: {
          busca: '',
          cabecalho: [
            { text: 'Nome', align: 'start', value: 'nome', },
            { text: 'Valor', value: 'valor' },
            { text: 'Data e Hora', value: 'created' },
          ],
          carregamentoCompleto: false,
          carregamentoMinimizado: false,
          conteudoCompleto: [],
          conteudoMinimizado: [],
          itensPorPagina: 5,
          pagina: 1,
        },
        pedido: {
          valor: 0.00,
          desconto: "",
          itensPedido: [],
        },
        pedidoDefault: {
          valor: 0.00,
          desconto: "",
          itensPedido: [],
        },
        itemPedido: {
          produtoId: '',
          descricao: '',
          preco: '',
          quantidade: 0,
        },
        itemPedidoDefault: {
          produtoId: '',
          descricao: '',
          preco: '',
          quantidade: 0,
        },
        avulso: {
          descricao: '',
          preco: '',
          quantidade: 1,
        },
        fullPage: true,
        isLoading: false,
        respostaTransacao: [],
        audio: '',
        dialogoCriaPin: false,
        dialogoSolicitaPin: false,
        dialogoCaptura: false,
        dialogoOperacao: false,
        dialogoHistorico: false,
        x: 0,
        dialogoItemAvulso: false,
        descricaoRecebimento: '',
        dialogoCompra: false,
        dialogoForcarTransacao: false,
        dialogoPerguntaEstorno: false,
        dialogoConsultaSaldo: false,
        dialogObs: false,
        obsProduto: '',
        tipoLeitura: 'CÂMERA',
        situacao: '',
        estornoObj: [],
        dialogoSelecaoMetodo: false,
        dialogoCamera: false,
        stream: null,
        metodoTransacao: '',
        ndef: null,
        modoCaptura: 'FACIAL',
        opcoesCaptura: [
          { text: 'Facial', value: 'FACIAL' },
          { text: 'Matrícula', value: 'MATRÍCULA' },
          { text: 'Nome', value: 'NOME' },
        ],
        autocompleteConsumidor: {
          busca: '',
          carregamento: false,
          conteudo: [],
          timeoutId: null,
        },
        totalCameras: 1,
        tipoTransacao: '',
      }
    },

    watch: {
      dialogoSolicitaPin() {
        if (this.dialogoSolicitaPin == true) {
          setTimeout(() => {
            document.getElementById('pinTransacao--0').focus()
          }, 400);
        }
      },
      dialogoCompra(newVal) {
            if (newVal) { // Se o diálogo foi aberto
                this.virtualScrollKey++; // Isso forçará o v-virtual-scroll a se recriar e "reconhecer" as mudanças
            }
      },
      dialogoOperacao() {
        if (this.dialogoOperacao == false) {
          setTimeout(() => {
            this.respostaTransacao = []
          }, 300);
        }
      },

      dialogoForcarTransacao() {
        if (this.dialogoForcarTransacao == false) {
          this.recarregaPedido()
        }
      },

      dialogoConsultaSaldo() {
        if (this.dialogoConsultaSaldo == true) {
          sessionStorage.removeItem('nfc')

          let interval = setInterval(() => {
            if (sessionStorage.getItem('nfc')) {
              this.fazerConsultaSaldo(sessionStorage.getItem('nfc'))
              clearInterval(interval)
              }
            }, 1000);
          }
        },

      dialogoCaptura() {
        if (this.dialogoCaptura == true) {
          sessionStorage.removeItem('nfc')

          let interval = setInterval(() => {
            if (sessionStorage.getItem('nfc')) {
              this.decodificar(sessionStorage.getItem('nfc'))
              clearInterval(interval)
            }
          }, 1000);
        }
      },

      tipoLeitura() {
        if (this.tipoLeitura == 'LEITOR') {
          this.codigoQrCode = ''
          setTimeout(() => {
            document.getElementById('campoCaptura').focus()
          }, 100);
        }
      },

      dialogoCamera(newValue) {
        if (!newValue) {
          //
        }
        else if (newValue) {
          //
        }
      },

      modoCaptura() {
        if (this.modoCaptura == 'FACIAL' && this.dialogoCamera) {
          //
        }
        else {
          //
        }

        this.codigoQrCode = ''
        this.autocompleteConsumidor.busca = ''
        this.autocompleteConsumidor.conteudo = []
      },

      'autocompleteConsumidor.busca'(val) {
        if (this.autocompleteConsumidor.timeoutId) {
          clearTimeout(this.autocompleteConsumidor.timeoutId)
        }

        if (val && val.length >= 3) {
          this.autocompleteConsumidor.timeoutId = setTimeout(() => {
            if (val && val !== this.pacientes) {
              this.carregaConsumidores(val)
            }
          }, 500)
        }
        else {
          this.autocompleteConsumidor.conteudo = []
        }
      },
    },

    computed: {
    ...mapState({
      user: state => state.userObj, // Acessa diretamente o estado `userObj`
      companyobj: state => state.companyObj, // Acessa diretamente o estado `companyObj`
    }),
    quantidadeDeItem() {
    return produtoId => {
      const item = this.pedido.itensPedido.find(item => item.produtoId === produtoId);
      return item ? item.quantidade : 0;
    };
  }
  },

    mounted() {
      if (sessionStorage.getItem('userPermission') == 'CAIXA' && sessionStorage.getItem('accToken')) {
        if (sessionStorage.getItem('userPermission') != null)
          this.$store.dispatch('Permission')
      }
      this.audio = new Audio(require("../../assets/beep.mp3"))
      this.usuario = JSON.parse(sessionStorage.getItem('user'))
      this.company = JSON.parse(sessionStorage.getItem('company'))
      this.lojista = JSON.parse(sessionStorage.getItem('lojista'))
      if (!this.usuario.pin) {
        this.dialogoCriaPin = true
      }
      this.mostraTransacoes()
      this.pegaProdutos()
    },

    beforeDestroy() {
      //
    },

    methods: {
      async pegaProdutos() {
        var vm = this;
        await axios.get(baseApiUrl + 'Produtos?filter={"where":{"and":[{"empresaId":"' + this.user.empresaId + '"},{"lojistaId":"' + this.user.lojistaId + '"},{"status":"ativo"}]}, "order":"ordem ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.iterador.conteudo = response.data
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao buscar produtos","DESCULPE")
        })
      },

      async salvarPin() {
        var vm = this;
        this.isLoading = true
        await axios.post(baseApiUrl + 'Usuarios/upsertWithWhere?where={"id":"' + this.user.id + '"}&access_token=' + sessionStorage.getItem('accToken'), {"pin": this.pin})
        .then(response => {
          if (response.data) {
            sessionStorage.setItem('user', JSON.stringify(response.data))
            this.isLoading = false
            this.dialogoCriaPin = false
            vm.$refs.chamaSnackbar.snack("#0288D1","PIN salvo!","INFORMAÇÃO")
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao salvar PIN","DESCULPE")
        })
      },

      alteraValor(valor) {
        this.valorTransacao = parseFloat(this.valorTransacao.replace(',','.')) + valor
      },

      abreLeituraQRCode() {
        if (this.valorTransacao != '0,00') {
          this.audio.play()

          if (this.companyobj.reconhecimentoFacial) {
            // this.dialogoSelecaoMetodo = true;
            this.selecionarMetodo('facial')
          }
          else {
            this.metodoTransacao = 'nfc';
            //faz o procedimento para o app ler o cartao
            sessionStorage.removeItem('ativanfc')
            sessionStorage.setItem('ativanfc', 'true')
            this.dialogoCaptura = true;
          }
        } else {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um valor para continuar!","ATENÇÃO")
        }
      },

      selecionarMetodo(metodo) {
        this.metodoTransacao = metodo;

        if (metodo === 'nfc') {
          this.abrirLeituraNFC()
        }
        else if (metodo === 'facial') {
          this.dialogoCamera = true
        }

        this.dialogoSelecaoMetodo = false
      },

      async abrirLeituraNFC() {
        let vm = this;
        
        if ('NDEFReader' in window) {
          try {
            this.ndef = new NDEFReader();
            await this.ndef.scan();

            this.ndef.onreading = event => {
              const decoder = new TextDecoder();

              for (const record of event.message.records) {
                if (record.recordType === "text") {
                  this.nfc = decoder.decode(record.data)
                  sessionStorage.setItem('nfc', this.nfc)
                }
              }
            };
          }
          catch (erro) {
            vm.$refs.chamaSnackbar.snack("#F9A825", erro, "ATENÇÃO")
          }
        }
        else {
          sessionStorage.removeItem('ativanfc')
          sessionStorage.setItem('ativanfc', 'true')
        }

        this.dialogoCaptura = true;
      },

      decodificar(decodedString) {
        this.codigoQrCode = decodedString
        this.dialogoSolicitaPin = true
        this.dialogoCaptura = false
      },

      async criarTransacao(forcarTransacao) {
        this.valorTransacao = this.pedido.valor.replace('.', ',')
        var vm = this;
        this.isLoading = true
        let dados = {
          "empresaId": this.user.empresaId,
          "atendenteId": this.user.id,
          "qrCode": this.codigoQrCode,
          "valor": this.valorTransacao,
          "tipoTransacao": 'CONSUMO',
          "formaTransacao": '',
          "pinUsuario": this.pinTransacao,
          "lojistaId": this.user.lojistaId,
          "itens": this.pedido.itensPedido,
          "forcarTransacao": forcarTransacao,
          "canalPedido": '',
        }

        const endpoint = this.metodoTransacao === 'facial' && this.modoCaptura == 'FACIAL' ? "CartoesConsumo/novaTransacaoFacial" : "CartoesConsumo/novaTransacao";

        if (this.metodoTransacao === 'facial') {
          dados.fotoBase64 = this.hashBase64;
        }

        await axios.post(baseApiUrl + endpoint + '?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.fechar()
            document.getElementById('campoValor') != null ? document.getElementById('campoValor').value = '0,00' : this.valorTransacao = '0,00'
            if (response.data.resultado == 'SUCESSO') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
              this.sessionStoragePrinter(this.company.cnpj, this.company.nome, this.lojista.nome, this.respostaTransacao.saldo, this.respostaTransacao.consumidor, this.pedido)
              this.mostraTransacoes()
              this.recarregaPedido()
              sessionStorage.removeItem('nfc')
            }
            else if (response.data.resultado == 'SALDO_INSUFICIENTE') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
            }
            else if (response.data.resultado == 'QRCODE_INVALIDO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","QR Code inválido","ATENÇÃO")
            }
            else if (response.data.resultado == 'TRANSACAO_INFORMADA_INVALIDA') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Transação informada é inválida","ATENÇÃO")
            }
            
            this.metodoTransacao = ''
            this.codigoQrCode = ''
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.data.error.message.includes('transação com as mesmas características')) {
            this.dialogoForcarTransacao = true
          } else {
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação (" + error.response.data.error.message + ")","DESCULPE")
          }
        })
      },

      sessionStoragePrinter(cnpjEmpresa, nomeEmpresa, lojista, novoSaldo, nomeCliente, itensPedido) {
        sessionStorage.setItem('nomeCliente', nomeCliente)
        sessionStorage.setItem('novoSaldo', novoSaldo)
        sessionStorage.setItem('itensPedido', this.geraImpressaoCupom58(itensPedido))
        sessionStorage.setItem('nomeEmpresa', nomeEmpresa)
        sessionStorage.setItem('cnpjEmpresa', cnpjEmpresa)
        sessionStorage.setItem('lojista', lojista)
        sessionStorage.setItem('imprimirVenda', 'true')

      },

      fechar() {
        this.dialogoSolicitaPin = false
        this.dialogoCaptura = false
        this.dialogoForcarTransacao = false
        this.pinTransacao = ''
      },

      async mostraHistorico() {
        var vm = this
        this.dialogoHistorico = true
        this.tabela.carregamentoCompleto = true
        this.tabela.conteudoCompleto = []

        await axios.get(baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"empresaId":"'+this.user.empresaId+'"},{"lojistaId":"'+this.user.lojistaId+'"},{"or":[{"atendenteId":"'+this.user.id+'"},{"atendenteId":""}]},{"or":[{"tipoTransacao":"CONSUMO"},{"tipoTransacao":"ESTORNO"}]}]},"include":["consumidor"],"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tabela.conteudoCompleto.push({
                "nome": response.data[i].consumidor ? response.data[i].consumidor.nome : 'Consumidor removido',
                "valor": response.data[i].valor,
                "tipoTransacao": response.data[i].tipoTransacao,
                "id": response.data[i].id,
                "created": response.data[i].created,
                "estornado": response.data[i].estornado,
              })
            }
          }
          this.tabela.carregamentoCompleto = false
        })
        .catch(() => {
          this.tabela.carregamento = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao carregar histórico","DESCULPE")
        })
      },

      async mostraTransacoes() {
        var vm = this
        this.tabela.carregamentoMinimizado = true
        this.tabela.conteudoMinimizado = []
        await axios.get(baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"empresaId":"'+this.user.empresaId+'"},{"lojistaId":"'+this.user.lojistaId+'"},{"or":[{"atendenteId":"'+this.user.id+'"},{"atendenteId":""}]},{"or":[{"tipoTransacao":"CONSUMO"},{"tipoTransacao":"ESTORNO"}]}]},"include":["consumidor"],"limit":5,"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudoMinimizado = response.data
          }
          this.tabela.carregamentoMinimizado = false
        })
        .catch(() => {
          this.tabela.carregamentoMinimizado = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao carregar transações","DESCULPE")
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      adicionaItem(produto) {

        // Primeiro, verificar se o produto já existe na lista de itensPedido
        const itemExistente = this.pedido.itensPedido.find(item => item.produtoId === produto.id);

        if (itemExistente) {
          // Se o produto já existe, apenas atualize a quantidade
          itemExistente.quantidade += 1;
          produto.quantidade = itemExistente.quantidade; // Atualiza a quantidade do produto para refletir a do item
        } else {
          // Se não existe, crie um novo item com as propriedades do produto
          const novoItem = {
            quantidade: 1, // A quantidade inicial deve ser 1 para um novo item
            descricao: produto.descricao,
            preco: produto.preco,
            produtoId: produto.id,
          };
          // Adiciona o novo item ao array de itensPedido
          this.pedido.itensPedido.push(novoItem);
          produto.quantidade = novoItem.quantidade;
        }

        // Atualizar o valor total do pedido
        // Garanta que o valor atual e o preço do produto sejam tratados como float
        // Se produto.preco já for um número, não é necessário usar replace
        // Atualizar o valor total do pedido, garantindo que todos os valores sejam tratados como números.
        this.pedido.valor = (parseFloat(this.pedido.valor) + parseFloat(produto.preco.replace(',','.'))).toFixed(2)
      },


      removeItem(produto) {
        const index = this.pedido.itensPedido.findIndex(item => item.produtoId === produto.id);

        // Se o item existe no pedido
        if (index !== -1) {
          const item = this.pedido.itensPedido[index];

          if (item.quantidade > 1) {
            // Decrementa a quantidade do item
            item.quantidade -= 1;
            produto.quantidade = item.quantidade;
            this.pedido.valor = (parseFloat(this.pedido.valor) - parseFloat(produto.preco.replace(',', '.'))).toFixed(2);
          } else {
            // Remove o item do pedido
            this.pedido.itensPedido.splice(index, 1);
            produto.quantidade = 0;
            this.pedido.valor = (parseFloat(this.pedido.valor) - parseFloat(produto.preco.replace(',', '.'))).toFixed(2);
          }
        }

        // Atualize sua lógica para 'this.x++' conforme necessário
      },


      openDialogObs(produto) {
        if (produto.quantidade > 0) {
          this.dialogObs= true
          this.produtoObs = produto
          this.pedido.itensPedido.forEach(item => {
            if (item.produtoId == this.produtoObs.id && item.observacao != '') {
              this.obsProduto = item.observacao
            }
          })
        } else {
          this.snackbar = true
            this.textoSnackbar = "Adicione " + produto.descricao + " para incluir observação"
        }
      },

      saveObs(){
        if(this.obsProduto != undefined){
        this.pedido.itensPedido.forEach(item => {
              if(item.produtoId == this.produtoObs.id){
                  item.observacao = this.obsProduto
                  this.closeObs()
              }
            })
        }
      },

      closeObs(){
        this.dialogObs= false
        this.obsProduto = ''
      },

      recarregaPedido() {
        this.pedido = Object.assign({}, this.pedidoDefault)
        this.pedido.itensPedido = []
        this.itemPedido = Object.assign({}, this.itemPedidoDefault)
        document.getElementById('campoValor') != null ? document.getElementById('campoValor').value = '0,00' : this.valorTransacao = '0,00'
        this.dialogoCompra = false
        this.pegaProdutos()
      },

      insereVendaAvulsa() {
        var vm = this
        if (this.avulso.preco == '0,00') {
          vm.$refs.chamaSnackbar.snack("orange","Informe um valor para adicionar a venda avulsa!","ATENÇÃO")
        }
        else if (!this.avulso.descricao) {
          vm.$refs.chamaSnackbar.snack("orange","Informe a descrição para adicionar a venda avulsa!","ATENÇÃO")
        }
        else {
          let avulso = []
          avulso = Object.assign({}, this.avulso)
          this.pedido.itensPedido.push(avulso)
          this.pedido.valor = (parseFloat(this.pedido.valor) + parseFloat(avulso.preco.replace(',','.'))).toFixed(2).replace('.',',')
          this.dialogoItemAvulso = false
          setTimeout(() => {
            this.avulso.descricao = ''
            document.getElementById('avulsoValor').value = '0,00'
          }, 2000)
        }
      },

      efetuarEstorno(item) {
        var vm = this

        if (!item.estornado) {
          let question = confirm('Deseja realmente efetuar o estorno no valor de R$' + item.valor + ' para ' + item.nome + '?')

          if (question) {
            this.situacao = 'ESTORNO'
            this.estornoObj = item
            this.dialogoSolicitaPin = true
          }
        } else {
          vm.$refs.chamaSnackbar.snack("orange","Transação já estornada anteriormente","ATENÇÃO")
        }
      },

      consultarSaldo() {
        if (this.codigoInscricao) {
          this.fazerConsultaSaldo(this.codigoInscricao)
        } else {
          this.dialogoCamera = true
          this.tipoTransacao = 'CONSULTA'
          this.audio.play()
        }
      },

      async fazerConsultaSaldo(decodedString) {
        var vm = this
        this.isLoading = true
        let resultado = await this.validaQrCode(decodedString, 'resultado')

        if (resultado == 'SUCESSO') {
          let saldo = await this.validaQrCode(decodedString, 'saldo')
          let consumidor = await this.validaQrCode(decodedString, 'consumidor')
          saldo = saldo == '' ? "0,00" : saldo
          vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + saldo, consumidor)
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
        
        this.dialogoConsultaSaldo = false
        this.tipoTransacao = ''
        this.isLoading = false
      },

      async fazerConsultaSaldoFacial() {
        let vm = this
        this.isLoading = true

        await axios.post(baseApiUrl + 'Consumidores/consultaSaldoFacial', { "fotoBase64": this.hashBase64, "empresaId": this.user.empresaId })
        .then(response => {
          if (response.data) {
            if (response.data.resultado == 'SUCESSO') {
              vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + response.data.saldo, response.data.consumidor)
            }
            else {
              vm.$refs.chamaSnackbar.snack("#F9A825", "Consumidor não localizado", "ATENÇÃO")
            }
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Consumidor não localizado", "ATENÇÃO")
        })

        this.hashBase64 = ''
        this.tipoTransacao = ''
        this.isLoading = false
      },

      async validaQrCode(qrCode, atributo) {
        let resultado
        await axios.post(baseApiUrl + 'QRCodes/validaQrcode', {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            resultado = response.data[atributo]
          }
        })
        return resultado
      },

      async criarEstorno() {
        let vm = this
        this.isLoading = true
        let dados = {
          "pin": this.pinTransacao,
          "extratoId": this.estornoObj.id,
          "atendenteId": this.user.id,
          "lojistaId": this.user.lojistaId,
        }

        await axios.post(baseApiUrl + 'ExtratoCartoes/estornarTransacao?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.dialogoSolicitaPin = false
            this.mostraHistorico()
            this.mostraTransacoes()
            this.isLoading = false
            this.estornoObj = []
            this.situacao = ''
            this.pinTransacao = ''
            vm.$refs.chamaSnackbar.snack("#0288D1", "Estorno salvo!", "INFORMAÇÃO")
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("red", error.response.data.error.message, "DESCULPE")
        })
      },

      async capturarFoto() {
        let vm = this;

        try {
          const foto = await this.$refs.camera.capturar();
          this.hashBase64 = foto;
          this.dialogoCamera = false;
          this.isLoading = true;

          if (this.hashBase64 != "") {
            this.isLoading = false;

            if (this.tipoTransacao == 'CONSULTA')
              this.fazerConsultaSaldoFacial()
            else
              this.criarTransacao(false)
              // this.dialogoSolicitaPin = true;
          }
          else {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao capturar foto, tente novamente!", "ERRO");
          }
        } catch (error) {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao capturar foto", "ERRO");
        }
      },


      /* Função para gerar a lista de pedidos que irá para o sessionStorage */

    geraListaPedidosCupom58(itensPedido) {
    let listaString = '';
    let separador = ' ';
    let larguraColQtd = 2;
    // Caso modifique o valor 15, deverá substituir tbm o valor na quebra da string observação match(/.{1,15}/g)
    let larguraColDesc = 15;
    let larguraColUnit = 5;
    let larguraColValor = 6;
    let listaTotalPedidos = [];
    let espacos = '';

    if (itensPedido.length < 1) {
      let texto = '\nPEDIDO SEM ITENS';
      let tamanhoLinha = 32;

      for (let i = 0; i < (tamanhoLinha - texto.length); i++) {
        espacos += ' ';
      }

      listaString = texto + espacos + '\n\n';
    }
    else {
      // Coloca os pedidos e seus adicionais em uma lista
      for (let i = 0; i < itensPedido.length; i++) {
        listaTotalPedidos.push(itensPedido[i]);

        if (itensPedido[i].adicionais) {
          if (itensPedido[i].adicionais.length > 0) {
            for (let f = 0; f < itensPedido[i].adicionais.length; f++) {
              itensPedido[i].adicionais[f].possuiAdicionais = true;
              itensPedido[i].adicionais[f].descricao = itensPedido[i].adicionais[f].quantidade.toString() +
                                                       ' AD ' +
                                                       itensPedido[i].adicionais[f].descricao
              listaTotalPedidos.push(itensPedido[i].adicionais[f]);
            }
          }
        }
      }

      for (let i = 0; i < listaTotalPedidos.length; i++) {
        let qtde = listaTotalPedidos[i].quantidade.toString();
        let descricao = listaTotalPedidos[i].descricao.toUpperCase().substring(0, larguraColDesc);
        let unit = listaTotalPedidos[i].preco.replace('.', ',');
        let totalPedido = 0;

        // Para coluna QTDE
        if (listaTotalPedidos[i].possuiAdicionais == true)
          listaString = listaString + this.calculaEspacos(larguraColQtd, '') + separador + descricao;
        else
          listaString = listaString + qtde + this.calculaEspacos(larguraColQtd, qtde) + separador + descricao;
        // Para coluna DESCRICAO
        listaString = listaString + this.calculaEspacos(larguraColDesc, descricao) + separador;
        // Para coluna UNIT
        listaString = listaString + this.calculaEspacos(larguraColUnit, unit) + unit + separador;
        // Para coluna VALOR
        totalPedido = parseFloat(unit.replace(',', '.')) * listaTotalPedidos[i].quantidade;
        totalPedido = totalPedido.toFixed(2).replace('.', ',');
        listaString = listaString + this.calculaEspacos(larguraColValor, totalPedido) + totalPedido + '\n';

        let obs = listaTotalPedidos[i].observacao;

        if (obs) {
          obs = 'OBS.: ' + obs.toLowerCase();
          obs = obs.match(/.{1,15}/g);

          for (let f = 0; f < obs.length; f++) {
            listaString = listaString + this.calculaEspacos(larguraColQtd, '') + separador + obs[f] + '\n';
          }
        }
      }
    }

    return listaString
  },

  calculaEspacos(tamanhoTotal, texto) {
    let espacos = '';

    for (let f = 0; f < (tamanhoTotal - texto.length); f++) {
      espacos += ' ';
    }

    return espacos;
  },

  geraImpressaoCupom58(pedido) {
    let cabecalho = '';

    // Cria cabeçalho da tabela
    cabecalho += '--------------------------------\n';
    cabecalho += 'QT DESCRIÇÃO       VL_UN  VALOR \n';
    cabecalho += '--------------------------------\n';

    return cabecalho + this.geraListaPedidosCupom58(pedido.itensPedido) + this.geraRodapeCupom58(pedido.valor, pedido.desconto);
  },

  geraRodapeCupom58(subTotal, desconto) {
    let rodape = '';
    let valorTotal = 0;
    let tamanhoLinha = 32;
    let espacos = '';
    let linhaVazia = '--------------------------------\n';
    let texto = '';

    // Caso não tenha subTotal, seu valor será zero
    if (subTotal)
      subTotal = parseFloat(subTotal.replace(',', '.'));
    else
      subTotal = 0;

    // Caso não tenha desconto, seu valor será zero
    if (desconto)
      desconto = parseFloat(desconto.replace(',', '.'));
    else
      desconto = 0;

    // Calcula o valor total
    valorTotal = subTotal - desconto;

    // Tranforma subTotal, desconto e valorTotal em string
    subTotal = subTotal.toFixed(2).replace('.', ',');
    desconto = desconto.toFixed(2).replace('.', ',');
    valorTotal = valorTotal.toFixed(2).replace('.', ',');

    rodape = linhaVazia;

    texto = 'TOTAL PEDIDO';
    espacos = '';

    // Calcula a quantidade de espaços para o valorTotal
    for (let i = 0; i < (tamanhoLinha - (texto.length + valorTotal.length)); i++) {
      espacos += ' ';
    }

    rodape += texto + espacos + valorTotal + '\n';

    return rodape;
  },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      onError(error) {
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao iniciar câmera: " + error, "ERRO");
      },

      onLoading(loading) {
        this.isLoading = loading;
      },

      async carregaConsumidores(data) {
        this.autocompleteConsumidor.carregamento = true

        let whereFilter = {
          "where": {
            "and": [
              { "empresaId": this.companyobj.id },
            ]
          },
          "order": "nome ASC"
        }

        if (!isNaN(data.replace(/\D/g, '')) && parseInt(data.replace(/\D/g, '')) > 0) {
          whereFilter.where.and.push({ "matricula": {"regexp": "/" + data + "/i" } })
        }
        else {
          whereFilter.where.and.push({ "nome": {"regexp": "/" + data + "/i"} })
        }

        await axios.get(baseApiUrl + 'Consumidores?filter=' + JSON.stringify(whereFilter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.autocompleteConsumidor.conteudo = response.data
          }
        })
        .catch(error => {
          this.$refs.chamaSnackbar.snack("red", "Problema ao buscar consumidores. " + error.response.data.error.message, "DESCULPE")
        })

        this.autocompleteConsumidor.carregamento = false
      },

      filterConsumidores(item, queryText) {
        let searchText = queryText.toLowerCase()
        let nome = item.nome ? item.nome.toLowerCase() : ''
        let matricula = item.matricula ? item.matricula.toLowerCase() : ''
        
        return nome.includes(searchText) || matricula.includes(searchText)
      },
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0px;
    background: linear-gradient(to right, #474d55, #474d55);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>